
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-business",
      function () {
        return require("private-next-pages/for-business/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-business"])
      });
    }
  